











import { defineComponent, PropType, provide } from '@nuxtjs/composition-api'
import useHelper from '@/utils/helper'
import { StoryblokComponent } from '~/types/storyblok-vue'

export interface GaSection extends StoryblokComponent<'section'> {
  content: StoryblokComponent<any>[]
  custom_classes: string
}

export default defineComponent({
  props: {
    blok: {
      type: Object as PropType<GaSection>,
      default: () => {}
    }
  },
  setup(props) {
    const { concatClasses, dashify } = useHelper()
    const classes = concatClasses(props.blok)

    const sectionLabelId = 'section' + props.blok._uid
    provide('ariaLabelId', sectionLabelId)

    return {
      classes,
      dashify,
      sectionLabelId
    }
  }
})
